Vgr.trackings = {
	general: {
		blockPageInterest: "imInterested",
		login: "login"
	},
	disposal: {
		followupAccess: {
			usingMenu: "goToDisposalsFollowupUsingMenu"
		},
		disposalModel: {
			usingMenu: "Home.Menu.AcessarModelosDestinacao"
		},
		flow: {
			durationCreateDestination: "durationToCreateDestination"
		},
		manifest: {
			followupAccessUsingMenu: "goToDisposalManifestsFollowupUsingMenu",
			followupAccessUsingDisposalFollowupScreen: "goToDisposalManifestsFollowupUsingDisposalFollowupScreen"
		},
		history: {
			attachCdf: "HistoricoDestinacao.Listagem.AnexarCdf"
		}
	},
	internal: {
		gathering: {
			goToNewPage: "Geracao.TelaAntiga.AcessarNovaTela",
			create: "Geracao.TelaAntiga.Criar",
			createSuccess: "Geracao.TelaAntiga.Criar.Sucesso",
			print: "Geracao.TelaAntiga.Imprimir",
			edit: "Geracao.TelaAntiga.Editar"
		},
		transfer: {
			closePopupNewFeature: "MovimentacaoInterna.FecharPopup",
			accessManualNewFeature: "MovimentacaoInterna.ManualAcessado"
		}
	},
	residueTraceability: {
		usingMenu: "RastreabilidadeResiduos.Abrir.Menu",
		accessManualNewFeature: "BI.RastreabilidadeResiduos.AcessarManual"
	},
	area: {
		create: "Area.Criar"
	},
	residue: {
		create: "Residuo.Criar"
	},
	mtrFollowup: {
		accessPageByDestination: "goToMtrFollowupByDestination"
	},
	bi: {
		metrics: {
			residueGenerationQuantity: "BI.Metrica.VisualizarDadosGeracaoQuantidade",
			residueDisposalQuantity: "BI.Metrica.VisualizarDadosDestinacaoQuantidade",
			residueDisposalCosts: "BI.Metrica.VisualizarDadosDestinacaoCustos",
			residueDisposalRecipientEfficiency: "BI.Metrica.VisualizarDadosDestinacaoEficienciaAcondicionamento",
			productionQuantity: "BI.Metrica.VisualizarDadosProducaoQuantidade"
		},
		reports: {
			createSavedReport: "BI.Relatorios.CriarRelatorioSalvo",
			generateSavedReport: "BI.Relatorios.GerarRelatorioSalvo",
			generateKpi: "BI.Relatorios.GerarIndicador",
			generateRelativeKpi: "BI.Relatorios.GerarComparacaoIndicadores",
			generateManagementInventory: "BI.Relatorios.GerarInventarioGerencial",
			generateResidueMovimentation: "BI.Relatorios.GerarMovimentacaoResiduos"
		},
		customReport: {
			accessManualNewFeature: "BI.Relatorios.AcessarManual"
		},
		emission: {
			accessManualNewFeature: "BI.Emissoes.Dashboard.AcessarManual"
		}
	},
	maturity: {
		access: "Maturidade.Acessar.Menu"
	},
	indicativeReport: {
		accessPage: "Bi.RelatorioIndicativo.AcessarDashboard",
		accessManualNewFeature: "Bi.RelatorioIndicativo.AcessarManual"
	},
	declarations: {
		rappIbamaGenerateReport: "Declaracao.RappIbama.GerarRelatorio",
		conama313GenerateReport: "Declaracao.Conama313.GerarRelatorio"
	},
	vertownNotifications: {
		close: "VisaoCliente.Comunicados.Fechar",
		remindLater: "VisaoCliente.Comunicados.LembrarMaisTarde",
		access: "VisaoCliente.Comunicados.Acessar"
	},
	services: {
		email: {
			suppliers: {
				actionPlans: "Servicos.Email.Fornecedores.PlanosDeAcao"
			}
		}
	}
};
